import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const ITerminalContributionService = ( createDecorator('terminalContributionsService'));
export { ITerminalContributionService };
